import { styled } from "@mui/material/styles";
import {
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  Box,
} from "@mui/material";
import { useShow } from "hooks/useShow";
import { match } from "assert";
import { Right } from "components/Svg";
import { head } from "lodash";
import Transitions from "components/Transitions";
import videoBg from "assets/images/home/video-bg.png";
import Grid from "@mui/material/Unstable_Grid2";
import { NavLink } from "react-router-dom";
import { IconLink } from "components/Svg";
import { useRef } from "react";

const BanBox = styled(Stack)`
  position: relative;
  width: 100%;
  height: calc(100vh - 70px); /* 让 Banner 充满首屏 */
  overflow: hidden;
  margin-top: 70px;
  background-size: auto 98%;
  background-repeat: no-repeat;
  background-position: center;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      height: "auto",
    },
  })};
`;

const Containter = styled(Stack)`
  height: 100%;
  width: 1200px;
  padding: 70px 25px 70px;
  box-sizing: border-box;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "0px 20px 60px",
    },
  })};
`;

const ConBox = styled(Stack)`
  position: relative;
  z-index: 2;
`;

const Head = styled(Typography)`
  color: #fff;
  font-size: 80px;
  line-height: 80px;
  margin-top: 30px;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "44px",
      lineHeight: "44px",
      textAlign: "center",
    },
  })};
`;

const SubHead = styled(Typography)`
  color: #999;
  font-size: 16px;
  font-family: KindSansRegular;
  margin-top: 30px;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "16px",
      fontSize: "16px",
      color: "#fff",
      textAlign: "center",
    },
  })};
`;

const BannerButton = styled(Button)`
  border-radius: 56px;
  height: 56px;
  min-width: 175px;
  background: #fff;
  border-radius: 45px;
  margin-top: 40px;
  cursor: default;
  &:hover {
    background: #fff;
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      minWidth: "140px",
      height: "40px",
      marginTop: "35px",
      fontSize: "14px",
    },
  })};
`;

const BanText = styled(Typography)`
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  font-family: KindSansRegular;
  color: #000;
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
  })};
`;

const VideoBox = styled("video")`
  width: 90%;
  height: auto;

  ${({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      width: "70%",
    },
  })};
`;

const LinkText = styled(Typography)`
  text-decoration: underline;
  color: #999;
  font-size: 20px;
  margin-right: 10px;
  &:hover {
    color: #fff;
  }
`;

const Banner = () => {
  const theme = useTheme();
  const downToMd = useMediaQuery(theme.breakpoints.down("md"));
  const { ref, isShow } = useShow();
  const videoRef = useRef<HTMLVideoElement>(null);

  const PoweredLink = () => {
    return (
      <NavLink to={"https://stableslabs.com/"} target={"_blank"}>
        <Stack justifyContent="flex-start" alignItems="center" direction="row">
          <LinkText>Powered by Stables Labs</LinkText>
          <IconLink />
        </Stack>
      </NavLink>
    );
  };

  return (
    <BanBox
      justifyContent="center"
      alignItems="center"
      direction="row"
      ref={ref}
    >
      <Containter justifyContent="center" alignItems="center" direction="row">
        <Grid
          justifyContent={downToMd ? "center" : "space-between"}
          alignItems={downToMd ? "center" : "space-between"}
          direction={downToMd ? "column-reverse" : "row"}
          container
          spacing={10}
        >
          <Grid xs={12} md={6}>
            <Stack
              justifyContent={downToMd ? "center" : "center"}
              alignItems={downToMd ? "center" : "flex-start"}
              direction={"column"}
              height={"100%"}
            >
              <Transitions delay={200} isShow={isShow}>
                <Box>
                  <PoweredLink />
                </Box>
              </Transitions>
              <Transitions delay={400} isShow={isShow}>
                <Head>Super Collateral for Everyone</Head>
              </Transitions>
              <Transitions delay={600} isShow={isShow}>
                <SubHead>
                  USD0x is a digital dollar backed by the U.S. Treasury bills,
                  offering a fully compliant, bankruptcy-remote, and
                  transferable digital asset that integrates seamlessly into the
                  DeFi ecosystem.
                </SubHead>
              </Transitions>
              <Transitions delay={700} isShow={isShow}>
                <Stack
                  alignContent="center"
                  justifyContent={"center"}
                  direction="row"
                >
                  {/* <a href=""> */}
                  <BannerButton variant="outlined">
                    <BanText>Stay Tuned</BanText>
                  </BannerButton>
                  {/* </a> */}
                </Stack>
              </Transitions>
            </Stack>
          </Grid>
          <Grid xs={12} md={6}>
            <Stack
              justifyContent={downToMd ? "center" : "flex-end"}
              alignItems="center"
              direction="row"
            >
              <VideoBox
                poster={videoBg}
                autoPlay
                loop
                muted
                webkit-playsinline
                playsInline
                disablePictureInPicture
                controls={false}
                id="bgvideo"
              >
                <source
                  src={`https://dcoj51524afgp.cloudfront.net/website/banner-return.mp4`}
                  type="video/mp4"
                />
              </VideoBox>
            </Stack>
          </Grid>
        </Grid>
      </Containter>
      {/* <VideoBox poster={videoBg} autoPlay loop muted>
        <source src={`/images/banner.mp4`} type="video/mp4" />
      </VideoBox>
      <ConBox
        justifyContent="space-between"
        alignItems="center"
        direction="column"
        height={"100%"}
      >
        <Stack alignContent="center" justifyContent={"center"} direction="row">
          <Transitions delay={200} isShow={isShow}>
            <a href="https://stables.hivefin.net/" target="_blank">
              <OutButton variant="outlined">
                <Stack
                  alignItems={"center"}
                  justifyContent={"flex-start"}
                  direction="row"
                >
                  <OutText mr={5}>Powered by Stables Labs</OutText>
                  <Right
                    width={upToMd ? "22px" : "16px"}
                    height={upToMd ? "40px" : "23px"}
                  />
                </Stack>
              </OutButton>
            </a>
          </Transitions>
        </Stack>
        <Box>
          <Transitions delay={400} isShow={isShow}>
            <HeadBox>
              <Head>{`Super Collateral`}</Head>
              <Head mt={10}>{`for Everyone`}</Head>
            </HeadBox>
          </Transitions>
          <Transitions delay={600} isShow={isShow}>
            <SubHead
              mt={40}
            >{`USD0x is a mirrorable, T-Bills backed stablecoin`}</SubHead>
          </Transitions>
        </Box>

        <Transitions delay={700} isShow={isShow}>
          <Stack
            alignContent="center"
            justifyContent={"center"}
            direction="row"
          >
            <a href="https://app.usdx.money/" target="_blank">
              <BannerButton variant="outlined">
                <BanText>Enter App</BanText>
              </BannerButton>
            </a>
          </Stack>
        </Transitions>
      </ConBox> */}
    </BanBox>
  );
};

export default Banner;
